import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  PublicRecordingComment,
  UpdateRecordingCommentDto,
} from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const updateRecordingComment = async ({
  orgId,
  recordingId,
  commentId,
  comment,
}: {
  orgId: string;
  recordingId: string;
  commentId: string;
  comment: UpdateRecordingCommentDto;
}): Promise<PublicRecordingComment> => {
  const response = await axiosClient.patch(
    `/${orgId}/recordings/${recordingId}/comments/${commentId}`,
    comment,
  );
  return response.data;
};

function useUpdateRecordingComment(
  {
    orgId,
    recordingId,
    commentId,
  }: {
    orgId: string;
    recordingId: string;
    commentId: string;
  },
  mutationOptions?: Partial<
    UseMutationOptions<
      PublicRecordingComment,
      HttpError,
      UpdateRecordingCommentDto
    >
  >,
) {
  return useMutation({
    mutationFn: (data: UpdateRecordingCommentDto) =>
      updateRecordingComment({
        orgId,
        recordingId,
        commentId,
        comment: data,
      }),
    ...mutationOptions,
  });
}

export { useUpdateRecordingComment };
